import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  Typography,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';

function DeleteModal({ open, user, onClose, onConfirm }) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('Delete user')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('Delete user message')}</DialogContentText>
        <Typography variant="h6" component="p" style={{ margin: '8px 0' }}>
          {user?.full_name}
        </Typography>
        <DialogContentText>{t('Permanent action warning')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {t('CANCEL')}
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          {t('CONFIRM')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteModal;
